/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

import ScanImg from '../../assets/images/florai/scan.png';
import LeafcardImg from '../../assets/images/florai/leafcard.png';
import HeroForestImg from '../../assets/images/florai/hero-forest.jpg';
import FloraiStoreButtons from './FloraiStoreButtons';

const chipClass = 'bg-[rgba(14,22,12,.7)] backdrop-blur border border-[rgba(238,242,236,.2)] text-[#EEF2EC] text-[.78rem] font-medium px-4 py-1.5 rounded-full';

// FlorAI app hero — dark forest panel with scanning phone mockup
export default function FloraiHero() {
  return (
    <section id="florai" className="florai px-4 !mb-4">
      <div className="relative overflow-hidden rounded-[32px] bg-[#0C150A] text-[#EEF2EC] min-h-[540px] md:min-h-[700px] flex flex-col max-w-[1400px] mx-auto">
        <div className="absolute inset-0 bg-[radial-gradient(130%_100%_at_50%_120%,#2C4222_0%,#16220F_55%,#0C150A_100%)]">
          <img
            src={HeroForestImg}
            alt=""
            aria-hidden="true"
            width="1200"
            height="1600"
            // eslint-disable-next-line react/no-unknown-property
            fetchpriority="high"
            className="absolute inset-0 w-full h-full object-cover object-center opacity-90"
          />
        </div>
        <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(120%_90%_at_50%_110%,rgba(12,21,10,.2)_0%,rgba(12,21,10,.55)_55%,rgba(12,21,10,.82)_100%),linear-gradient(180deg,rgba(12,21,10,.55)_0%,rgba(12,21,10,.12)_30%,rgba(12,21,10,.25)_100%)]" />

        <div className="relative z-10 flex-1 max-w-[1200px] w-full mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          {/* Left: copy + store buttons + stats */}
          <Fade direction="up" triggerOnce>
            <div>
              <span className="inline-flex items-center gap-2 text-[.72rem] font-bold tracking-[.14em] uppercase text-[#98CC6B] border border-[rgba(152,204,107,.35)] px-3.5 py-1.5 rounded-full mb-5">
                A Drava Studio product
              </span>
              <h1 className="mb-6 leading-[.98] tracking-tight [text-wrap:balance]">
                <span className="block !font-medium text-[clamp(3.2rem,7.5vw,5.6rem)] text-[#EEF2EC]">Forage</span>
                <span className="block font-instrument-serif italic !font-normal text-[clamp(3.4rem,8vw,6rem)] text-[#EEF2EC]">Smarter.</span>
              </h1>
              <p className="mb-7 text-[1.12rem] text-[#D8E2D3] max-w-md leading-normal">
                AI-powered identification, toxicity warnings, and care — for
                {' '}
                <em className="font-instrument-serif text-[1.2em]">safer</em>
                {' '}
                plants and mushrooms.
              </p>
              <FloraiStoreButtons variant="light" />
              <div className="flex gap-7 flex-wrap mt-8">
                <div>
                  <b className="text-[1.3rem] font-bold block text-[#EEF2EC]">10,000+</b>
                  <span className="text-[.8rem] text-[#AFBEA8]">species recognized</span>
                </div>
                <div>
                  <b className="text-[1.3rem] font-bold block text-[#EEF2EC]">2s</b>
                  <span className="text-[.8rem] text-[#AFBEA8]">average scan</span>
                </div>
                <div>
                  <b className="text-[1.3rem] font-bold block text-[#EEF2EC]">Free</b>
                  <span className="text-[.8rem] text-[#AFBEA8]">safety features</span>
                </div>
              </div>
            </div>
          </Fade>

          {/* Right: floating phone with scan line + result chips + foraging card */}
          <Fade direction="up" delay={150} triggerOnce>
            <div className="hidden md:flex justify-center items-center min-h-[560px] py-6">
              {/* Floating chips and result card anchor to the phone frame itself */}
              <div className="relative flex-none">
                <div className="w-[264px] h-[548px] rounded-[42px] bg-[#0D1A11] border-[9px] border-[#1C2618] shadow-[0_50px_90px_rgba(0,0,0,.55)] relative overflow-hidden rotate-3 animate-float">
                  <img src={ScanImg} alt="FlorAI camera scanning leaves" className="absolute inset-0 w-full h-full object-cover" />
                  <span className="florai-sweep absolute left-6 right-6 h-0.5 rounded" />
                  {/* App mode chips live inside the screen like real camera UI */}
                  <div className="absolute top-14 inset-x-0 flex flex-col items-center gap-2">
                    <div className="flex gap-1.5">
                      <span className={chipClass}>Identify</span>
                      <span className="bg-[#98CC6B] text-[#24361B] text-[.78rem] font-semibold px-4 py-1.5 rounded-full shadow-lg">Safety</span>
                      <span className={chipClass}>Care</span>
                    </div>
                  </div>
                </div>
                <div className="absolute -bottom-5 -right-24 w-[200px] bg-[#101A0D] border border-[rgba(238,242,236,.12)] rounded-[18px] p-3 shadow-[0_24px_48px_rgba(0,0,0,.45)]">
                  <div className="flex items-baseline gap-1.5 mb-2.5">
                    <b className="text-[.9rem] text-[#EEF2EC]">Smart</b>
                    <em className="font-instrument-serif text-[#EEF2EC]">Foraging</em>
                  </div>
                  <img src={LeafcardImg} alt="Hibiscus leaves" className="w-full h-[118px] object-cover rounded-xl block" />
                  <div className="flex items-center gap-2 mt-2.5">
                    <span className="text-[.85rem] font-semibold text-[#EEF2EC]">FlorAI</span>
                    <span className="ml-auto bg-[#98CC6B] text-[#24361B] text-[.68rem] font-bold px-3 py-1 rounded-full">Care</span>
                    <span className="w-[26px] h-[26px] rounded-full border border-[rgba(238,242,236,.3)] grid place-items-center text-[#EEF2EC] text-[.7rem]">↗</span>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
}
